import { render } from "./MenuSection.vue?vue&type=template&id=4ff2455a"
import script from "./MenuSection.vue?vue&type=script&lang=js"
export * from "./MenuSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MenuSection.vue"]])

export default __exports__